module.exports = __webpack_public_path__ + "img/logo_partner.e566f5a5.png";